/**
 * @description header3 button menu
 * @author wangfupeng
 */

import HeaderButtonMenuBase from './HeaderButtonMenuBase'

class Header3ButtonMenu extends HeaderButtonMenuBase {
  title = 'H3'
  type = 'header3'
}

export default Header3ButtonMenu
